var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAchievementPolygon = function SvgAchievementPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 741
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    fillRule: "evenodd",
    d: "M505.343 826.84 79.193 671.734.443 225.124 347.845-66.381l426.15 155.107 78.75 446.61z",
    opacity: 0.102
  })));
};
export default SvgAchievementPolygon;